import cn from 'clsx'
import { motion, AnimatePresence } from 'framer-motion'

// Components
import { Tooltip, IconLoopLarge, IconLoopLoading, IconSmallPlus, IconSmallMinus } from '@tracklib/kit'

import styles from './loopbutton.css'

type LoopButtonProps = {
  handleLoopToggle: () => void
  handleDecreaseBars: () => void
  handleIncreaseBars: () => void
  loopBars: number
  isLooping: boolean
  className?: string
  isLoading: boolean
}

const LoopButton = ({
  handleLoopToggle,
  isLooping,
  handleDecreaseBars,
  handleIncreaseBars,
  loopBars,
  className,
  isLoading,
}: LoopButtonProps): JSX.Element => (
  <div data-tooltip-wrapper className={cn(className)}>
    <AnimatePresence>
      {!localStorage.getItem('hasLooped') && (
        <motion.div
          key="tooltip"
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 15, opacity: 0, scale: 0.9 }}
          initial={{ y: 15, opacity: 0, scale: 0.9 }}
        >
          <Tooltip active className={styles.loopButtonTooltip} onClick={handleLoopToggle}>
            Try the loop player!{' '}
            <span role="img" aria-label="Fire emoji">
              🔥
            </span>
          </Tooltip>
        </motion.div>
      )}
    </AnimatePresence>
    <div className={cn(styles.wrapper, isLooping && styles.active, isLoading && styles.isLoading)} title="Loop">
      <button className={styles.decrease} disabled={!isLooping} onClick={handleDecreaseBars} tabIndex={isLooping ? 0 : -1}>
        <IconSmallMinus />
      </button>
      <button className={styles.toggle} onClick={handleLoopToggle} datatesting="toggle_loop">
        <span className={styles.bars}>{loopBars}</span>
        {isLoading ? <IconLoopLoading className={styles.iconLoopLoading} /> : <IconLoopLarge className={styles.iconLoop} />}
      </button>
      <button className={styles.increase} disabled={!isLooping} onClick={handleIncreaseBars} tabIndex={isLooping ? 0 : -1}>
        <IconSmallPlus />
      </button>
    </div>
  </div>
)

export default LoopButton
